import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import './assets/styles.css';

ReactDOM.render(
  <React.StrictMode> 
    <GoogleReCaptchaProvider
      reCaptchaKey="6LfKORIaAAAAAA5g191QVPrZuIhOa5rI_TL-ceTG"
      language="es-419"
      scriptProps={{
        async: true,
        defer: true
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
